import { format } from "date-fns";
import { CATEGORY_MAP } from "@/data/categories";

export const memoryDate = (ev) => {
  if (!ev.event_date) return "No date";
  try { return format(new Date(ev.event_date), "d MMM yyyy"); } catch { return ev.event_date; }
};

export const memorySummary = (ev) =>
  (ev.description || ev.prompt_answer || ev.reflection_item || ev.subtype || "").replace(/\s+/g, " ").trim();

const dateKey = (ev) => ev.event_date || "";

export const sortMemories = (items, sort = "oldest") => {
  const list = [...items];
  if (sort === "title") return list.sort((a, b) => (a.title || "").localeCompare(b.title || ""));
  return list.sort((a, b) => {
    if (!dateKey(a) || !dateKey(b)) return dateKey(a) ? -1 : dateKey(b) ? 1 : 0;
    return sort === "newest" ? dateKey(b).localeCompare(dateKey(a)) : dateKey(a).localeCompare(dateKey(b));
  });
};

export const MemoryRow = ({ event, onSelect, showSeason = false, paper = false }) => {
  const cat = CATEGORY_MAP[event.category];
  const summary = memorySummary(event);
  return (
    <li data-testid={`memory-row-${event.id}`} className="group">
      <button type="button" onClick={() => onSelect(event)}
        className="grid w-full grid-cols-1 items-baseline gap-x-4 gap-y-0.5 rounded-md px-3 py-3 text-left transition-colors hover:bg-[#F4EBDD] sm:grid-cols-[120px_1fr]">
        <span data-testid={`memory-date-${event.id}`} className={paper
          ? "inline-block -rotate-2 font-['Caveat',cursive] text-xl leading-none text-[#A84A32] underline-offset-4 group-hover:underline sm:text-[22px]"
          : "font-serif text-xs text-[#A84A32] underline-offset-4 group-hover:underline sm:text-sm"}>
          {memoryDate(event)}
        </span>
        <span className="min-w-0">
          <span className="flex flex-wrap items-baseline gap-x-2">
            <span data-testid={`memory-title-${event.id}`} className="font-serif text-lg leading-snug text-[#2C2A28]">{event.title}</span>
            {showSeason && <span className="text-[11px] uppercase tracking-wide text-[#8A7F76]">{event.season}</span>}
            {cat && <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: cat.color }} title={cat.label} />}
          </span>
          {summary && <span data-testid={`memory-summary-${event.id}`} className="mt-0.5 block truncate text-sm text-[#6B635B]">{summary}</span>}
        </span>
      </button>
    </li>
  );
};

export const MemoryList = ({ items, onSelect, showSeason, testId, paper = false }) => (
  <ul data-testid={testId} className={paper
    ? "space-y-1"
    : "divide-y divide-dashed divide-[#4A4540]/15 rounded-xl border border-[#4A4540]/10 bg-[#FFFCF6] px-2 shadow-sm"}>
    {items.map((ev) => <MemoryRow key={ev.id} event={ev} onSelect={onSelect} showSeason={showSeason} paper={paper} />)}
  </ul>
);
